export enum LgoHydroteaterCatalystRun {
  EOR = 'EOR',
  SOR = 'SOR',
}
export enum LgoYieldProfile {
  HIGH = 'High',
  LOW = 'Low',
}
